export const CARD_STATES = {
    QUANTIC: 'QUANTIC',
    WEEKLY_PLAN: 'WEEKLY_PLAN',
    DOING: 'DOING',
    DONE: 'DONE',
};

export const CARD_STATES_FORMATTED = {
    QUANTIC: gettext('To do'),
    WEEKLY_PLAN: gettext('Weekly Plan'),
    DOING: gettext('In Progress'),
    DONE: gettext('Done'),
};

export const CARD_STATES_OPTIONS = [
    { value: CARD_STATES.QUANTIC, label: gettext('To do') },
    { value: CARD_STATES.WEEKLY_PLAN, label: gettext('Weekly Plan') },
    { value: CARD_STATES.DOING, label: gettext('In Progress') },
    { value: CARD_STATES.DONE, label: gettext('Done') },
];

export const ItemTypes = {
    CARD: 'card',
};
